import { render, staticRenderFns } from "./Limitations.vue?vue&type=template&id=2bedf8f3&scoped=true"
import script from "./Limitations.vue?vue&type=script&lang=js"
export * from "./Limitations.vue?vue&type=script&lang=js"
import style0 from "./Limitations.vue?vue&type=style&index=0&id=2bedf8f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedf8f3",
  null
  
)

export default component.exports